import {
  Component,
  HostListener,
  Inject,
  Input, OnDestroy,
  OnInit, PLATFORM_ID
} from '@angular/core';
import {Router} from "@angular/router";
import {
  EventItemType,
  Organiser,
  RequestFilter,
  RequestStatus,
  UserDetail, Request, Message
} from "@model";
import {
  CONTACT_ROUTE,
  USER_PROFILE_DASHBOARD_ROUTE,
  EVENT_CALENDAR_ROUTE,
  FINISHED_EVENTS_ROUTE,
  LANDING_ROUTE,
  LIVE_RESULTS,
  LOGIN_ROUTE,
  PRIVACY_POLICY_ROUTE,
  PRIVATE_EVENT_CALENDAR_ROUTE,
  PRIVATE_FINISHED_EVENTS_ROUTE,
  PRIVATE_LIVE_RESULTS,
  SIGNUP_ROUTE,
  USER_PROFILE_VIEW_ROUTE,
  USER_PROFILE_EDIT_ROUTE,
  USER_MESSAGES,
  SERIES_ROUTE, PRIVATE_SERIES_ROUTE, ORGANISER_EVENTS
} from "src/app/app-routing.module";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from '@ngneat/transloco';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {
  AuthenticationService, LoaderService,
  MessageService,
  RequestService,
  TOAST_STATE, ToastService,
  UserDetailService
} from "@services";
import {AbstractComponent} from "../abstract.component";
import {NewOrganiserModalComponent} from "../new-organiser-modal/new-organiser-modal.component";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {environment} from "@environment";

@Component({
  selector: 'app-page-header-public-alt',
  templateUrl: './page-header-public-alt.component.html',
  styleUrls: ['./page-header-public-alt.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        opacity: 1,
        transform: 'translate3d(0, 60px, 0)'
      })),
      state('inLanding', style({
        opacity: 1,
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        opacity: 0,
        transform: 'translate3d(0, calc(-100% - 96px), 0)'
      })),
      transition('in => out', animate('300ms ease-out')),
      transition('out => in', animate('300ms ease-in')),
      transition('inLanding => out', animate('300ms ease-out')),
      transition('out => inLanding', animate('300ms ease-in'))
    ]),

    trigger('searchSlideInOut', [
      state('hidden', style({
        opacity: 0,
        transform: 'translateY(-100%)',
        display: 'none'
      })),
      state('visible', style({
        opacity: 1,
        transform: 'translateY(0)',
        display: 'flex'
      })),
      transition('hidden => visible', animate('300ms ease-in')),
      transition('visible => hidden', animate('200ms ease-out'))
    ])
  ]
})
export class PageHeaderPublicAltComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() additionalClass: string | undefined;
  @Input() isLanding: boolean = false;
  @Input() isTopBannerVisible: boolean = false;

  currentUserDetails: UserDetail | undefined;
  currentUrl: string = "";
  public currentWindowWidth: number = 0;
  isMobileMenuVisible: boolean = false;
  unreadMessages: Message[] | undefined;
  isSearchVisible: boolean = false;

  constructor(private router: Router, public authenticationService: AuthenticationService,
              private modalService: NgbModal, private requestService: RequestService,
              private userService: UserDetailService, private translocoService: TranslocoService,
              private messageService: MessageService, @Inject(DOCUMENT) private document: Document,
              private loaderService: LoaderService, @Inject(PLATFORM_ID) private platformId: Object,
              private toastService:ToastService) {
    super();
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    this.currentUrl = this.document.location.href;

    this.subscriptions.push(this.userService.currentUserDetails.subscribe((userDetails: UserDetail | undefined): void => {
      this.currentUserDetails = userDetails;
    }));

    if (this.authenticationService.isAuthenticated()) {
      this.messageService.getUserMessages(false).subscribe((messages: Message[]) => {
        this.unreadMessages = messages;
      });
    }
  }

  override ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.document.body.classList.remove('overflow-hidden');
    }
  }

  goToMessages(messageFilter: boolean) {
    this.router.navigate([USER_MESSAGES], {queryParams: {read: messageFilter}});
  }

  toggleMobileMenuVisibility() {
    if (this.currentWindowWidth < 1400) {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;

      if (isPlatformBrowser(this.platformId)) {
        if (this.isMobileMenuVisible) {
          this.document.body.classList.add('overflow-hidden');
          this.isSearchVisible = false;
        } else {
          this.document.body.classList.remove('overflow-hidden');
        }
      }
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }

  goToLogin() {
    this.router.navigate([LOGIN_ROUTE]);
  }

  goToSignup() {
    this.router.navigate([SIGNUP_ROUTE]);
  }

  goToFinished() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_FINISHED_EVENTS_ROUTE : FINISHED_EVENTS_ROUTE]);
  }

  goToLiveResults() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_LIVE_RESULTS : LIVE_RESULTS]);
  }

  goToRegistered() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([USER_PROFILE_DASHBOARD_ROUTE], {queryParams: {typeOfRace: EventItemType.MY_REGISTERED}});
  }

  goToFavorites() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([USER_PROFILE_DASHBOARD_ROUTE], {queryParams: {typeOfRace: EventItemType.MY_FAVORITE}});
  }

  goToMyFinished() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([USER_PROFILE_DASHBOARD_ROUTE], {queryParams: {typeOfRace: EventItemType.MY_FINISHED}});
  }

  onClickToLogoImage() {
    if (this.isMobileMenuVisible) {
      this.toggleMobileMenuVisibility();
    }
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_EVENT_CALENDAR_ROUTE : LANDING_ROUTE]);
  }

  onEventCalendar() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_EVENT_CALENDAR_ROUTE : EVENT_CALENDAR_ROUTE]);
  }

  goToSeries() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_SERIES_ROUTE : SERIES_ROUTE]);
  }

  logout() {
    this.toggleMobileMenuVisibility();
    this.authenticationService.logout();
  }

  onOpenProfile() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([USER_PROFILE_EDIT_ROUTE]);
  }

  goToMyTracey() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([USER_PROFILE_VIEW_ROUTE]);
  }

  isRouteActive(route: string): boolean {
    var isActive: boolean = false;
    switch (route) {
      case "EVENT_CALENDAR":
        isActive = this.currentUrl.includes("eventCalendar");
        break;
      case "FINISHED":
        isActive = this.currentUrl.includes("finishedEvents");
        break;
      case "CONTACT":
        isActive = this.currentUrl.includes("contact");
        break;
      case "PRIVACY":
        isActive = this.currentUrl.includes("privacy");
        break;
      case "LIVE_RESULTS":
        isActive = this.currentUrl.includes("liveResults");
        break;
      case "SIGN_UP":
        isActive = this.currentUrl.includes("signup");
        break;
      case "MY_RACES":
        isActive = this.currentUrl.includes("userProfileDashboard");
        break;
      case "MY_REGISTERED":
        isActive = this.currentUrl.includes("userProfileDashboard");
        break;
      case "MY_FINISHED":
        isActive = this.currentUrl.includes("userProfileDashboard");
        break;
      case "USER_PROFILE_DASHBOARD_ROUTE":
        isActive = this.currentUrl.includes("userProfileDashboard");
        break;
      case "USER_PROFILE_EDIT":
        isActive = this.currentUrl.includes("userProfileEdit");
        break;
      case "USER_PROFILE_VIEW_ROUTE":
        isActive = this.currentUrl.includes("myTracey");
        break;
      case "SERIES":
        isActive = this.currentUrl.includes("leagues");
        break;
    }
    return isActive;
  }

  goToPrivacyPolicy() {
    this.toggleMobileMenuVisibility();
    this.router.navigate([PRIVACY_POLICY_ROUTE]);
  }

  goToContact() {
    this.router.navigate([CONTACT_ROUTE]);
  }

  onOrganiserButtonClick() {
    if (this.authenticationService.isAdminstrator() || this.authenticationService.isOrganiser()) {
      this.goToOrganizerModule();
    } else {
      this.openOrganiserRequestModule();
    }
  }

  private goToOrganizerModule() {
    this.router.navigate([ORGANISER_EVENTS]);
  }

  private openOrganiserRequestModule() {
    this.requestService.fetchRequestsCount(new RequestFilter(RequestStatus.ON_HOLD, this.currentUserDetails?.userId)
    ).subscribe((count: number) => {
      let organiserRequestSent: boolean = (count ?? 0) > 0;

      const windowClasses = ['new-organiser-modal'];
      if (organiserRequestSent) {
        windowClasses.push('new-organiser-modal--request-sent');
      }

      const modalRef: NgbModalRef = this.modalService.open(NewOrganiserModalComponent, {
        centered: true,
        windowClass: windowClasses.join(' ')
      });
      modalRef.componentInstance.title = this.translocoService.translate("request.header.title");
      modalRef.componentInstance.requestSent = organiserRequestSent;
      modalRef.result.then((organiser: Organiser): void => {
        this.loaderService.startLoading()
        this.requestService.sendOrganiserRequest(Request.createOrganiserRequest(organiser), () => {
          this.loaderService.dismissLoading()
          this.toastService.showToast(TOAST_STATE.success,
            this.translocoService.translate("newOrganiser.request.sent.success"));
        }, (errorCode?: number) => {
          this.loaderService.dismissLoading()
          if (errorCode === RequestService.EXISTING_ORGANISER_REQUEST_ON_HOLD) {
              this.toastService.showToast(TOAST_STATE.danger,
                this.translocoService.translate("newOrganiser.request.alreadySent"));
            } else {
              this.toastService.showToast(TOAST_STATE.danger,
                this.translocoService.translate("newOrganiser.request.alreadySent.error"));
            }
        });
      }, (_: any): void => {
        /// on modal dismiss, ignore
      });
    });
  }

  toggleSearch() {
    this.isSearchVisible = !this.isSearchVisible;
  }

  protected readonly environment = environment;
}
